module.exports = __webpack_public_path__ + "static/media/Enviroment.b333bb8a.png";